import { Outlet, Route, Routes } from 'react-router-dom';
import { LoginCallback } from '@okta/okta-react';
import { 
    DeductionsPage, 
    DeductionDetailsPage,
    DisputesPage, 
    HomePage, 
    InvoicesPage, 
    PaymentsPage, 
    PaymentDetailsPage, 
    BillbackDetailsPage,
    RepayDetailsPage,
    RootLayout, 
    InvoiceDetailsPage, 
    CreateDisputePage,
    UploadInvoicePage, 
    DisputeDetailsPage, 
    UserSettingsPage,
    SearchPage,
    CreditDetailsPage
} 
from 'pages';
import NotFoundPage from 'components/NotFoundPage/NotFoundPage';

export default function AppRoutes() {
    return (
        <Routes>
            <Route path="" element={<RootLayout />}>
                <Route index element={<HomePage />} />
                <Route path="accounts/:accountId" element={<Outlet />}>
                    <Route path="deductions" element={<DeductionsPage />} />
                    <Route path="vendors/:vendorId/deductions/:invoiceId" element={<DeductionDetailsPage />} />
                    <Route path="vendors/:vendorId/deductions/:invoiceId/:referenceId?" element={<DeductionDetailsPage />} />
                    <Route path="disputes" element={<DisputesPage />} />
                    <Route path="disputes/:disputeId" element={<DisputeDetailsPage />} />
                    <Route path="invoices" element={<InvoicesPage />} />
                    <Route path="vendors/:vendorId/invoices/:invoiceId" element={<InvoiceDetailsPage />} />
                    <Route path="payments" element={<PaymentsPage />} />
                    <Route path="vendors/:vendorId/payments/:paymentId" element={<PaymentDetailsPage />} />
                    <Route path="vendors/:vendorId/billback/:invoiceId" element={<BillbackDetailsPage />} />
                    <Route path="vendors/:vendorId/credit/:invoiceId" element={<CreditDetailsPage />} />
                    <Route path="vendors/:vendorId/repay/:invoiceId" element={<RepayDetailsPage />} />
                    <Route path="search" element={<SearchPage />} />
                </Route>
                <Route path="createdispute" element={<CreateDisputePage />} />
                <Route path="deductions" element={<DeductionsPage />} />
                <Route path="disputes" element={<DisputesPage />} />
                <Route path="disputes/:disputeId" element={<DisputeDetailsPage />} />
                <Route path="invoices" element={<InvoicesPage />} />
                <Route path="payments" element={<PaymentsPage />} />
                <Route path="search" element={<SearchPage />} />
                <Route path="uploadinvoice" element={<UploadInvoicePage />} />
                <Route path="implicit/callback" element={<LoginCallback />} />  
                <Route path="user" element={<UserSettingsPage />} />
                <Route path="*" element={<NotFoundPage />} />
            </Route>
        </Routes>
    )
}
